import Card from '../Card';
import ProjectCardProps from './ProjectCardProps';

export default function CreateGeneralProjectCard({
  project,
  className,
  onMutate,
}: ProjectCardProps) {
  return (
    <Card key={project.id} project={project} className={className?.base}>
      <Card.Interactions project={project} onMutate={onMutate} />
      <Card.Banner url={project.image} />
      <Card.Title title={project.title} />
      <Card.Tags tool={project.tool} flags={project.flags} />
      <Card.FlexGroup>
        <Card.PublushDate publishAt={project.createdAt} />
        <Card.Owners owners={project.users} />
      </Card.FlexGroup>
    </Card>
  );
}
